const config = JSON.parse(process.env["REACT_APP_CONFIG"])

export default config
